import { type HorizonTheme } from 'utils/color/horizonTheme';

import { type TurbineInspections } from './types';

export const getTurbineColor = (theme: HorizonTheme, severity?: number) => {
  switch (severity) {
    case 5:
      return theme.red;
    case 4:
      return theme.orange;
    case 3:
    case 2:
    case 1:
      return theme.green;
    default:
      return theme.mapPicturePinStroke;
  }
};

export const getTurbineInspectionData = (inspections: TurbineInspections) => {
  const { nodes = [] } = inspections ?? {};

  if (!nodes.length) {
    return;
  }

  const latestInspection = nodes[0];

  const maxSeverity =
    latestInspection?.horizonDamageObservations?.reduce(
      (max, obs) => Math.max(max, obs?.attrs?.Severity ?? 0),
      0
    ) || undefined;

  return {
    id: latestInspection?.id,
    inspectionDate: latestInspection?.inspectionDate ?? undefined,
    maxSeverity: maxSeverity,
  };
};
